import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useSharedActions, useSharedDispatch, useSharedSelector } from "../../store/SharedProvider";
import MessageType from "../../enums/robot/rsw/message-types";
import { ActionType } from "../../enums/command-hub/command-buttons";
import CircularProgress from "@mui/material/CircularProgress";
import { selectIsWebApp } from "../../store/app-configurations/app-configurations-selectors";

const ForceSyncButton: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useSharedDispatch();

  const isWebapp = useSharedSelector((state) => selectIsWebApp(state));

  const { sendRobotWebsocketMessage } = useSharedActions();

  const [isSyncing, setIsSyncing] = useState(false);

  const syncClickHandler = () => {
    setIsSyncing(true);
    if (isWebapp){
    } else {
      dispatch(sendRobotWebsocketMessage({ type: MessageType.Actions, message: { action: ActionType.ForceSync } }));
    }
  };

  return (
    <React.Fragment>
      {!isWebapp && <Button onClick={syncClickHandler}>{isSyncing ? <CircularProgress size={24} /> : t("button-sync")}</Button>}
    </React.Fragment>
  );
};

export default ForceSyncButton;
